import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbySeo } from 'gatsby-plugin-next-seo'
import { useIntl } from 'gatsby-plugin-react-intl'
import useLanguageAlternates from '../../hooks/useLanguageAlternates'

const query = graphql`
  {
    site {
      siteMetadata {
        siteDesc: description
        siteTitle: title
        siteUrl
        author
        email
        keywords
      }
    }
  }
`
const SEO = ({ title, description, pathname, noindex }) => {
  const intl = useIntl()
  const { site } = useStaticQuery(query)
  const { siteUrl, siteDesc, siteTitle, author, email, keywords } = site.siteMetadata

  const isDefaultLocale = intl.locale === intl.defaultLocale
  const isHomePage = pathname === '/'

  const localePrefix = isDefaultLocale ? '' : isHomePage ? `/${intl.locale}/` : `/${intl.locale}`
  const canonical = pathname ? `${siteUrl}${localePrefix}${isHomePage ? '' : `${pathname}/`}` : null

  const canonicalProps = { rel: 'canonical', href: canonical }
  const languageAlternates = useLanguageAlternates(siteUrl, pathname)

  return (
    <GatsbySeo
      title={title}
      titleTemplate={`%s | ${siteTitle}`}
      description={description || siteDesc}
      language={intl.locale}
      canonical={canonicalProps.href}
      noindex={noindex}
      metaTags={[
        {
          property: 'author',
          content: author,
        },
        {
          property: 'email',
          content: email,
        },
        {
          property: 'keywords',
          content: keywords,
        },
      ]}
      openGraph={{
        url: canonicalProps.href,
        title: `${title} | ${siteTitle}`,
        site_name: `${siteTitle}`,
        description: description || siteDesc,
        images: [
          {
            url: `${siteUrl}/images/og-image.png`,
            width: 1200,
            height: 630,
            alt: `${siteTitle}`,
          },
        ],
      }}
      languageAlternates={languageAlternates}
    />
  )
}

SEO.defaultProps = {
  title: null,
  description: null,
  lang: `en`,
  meta: [],
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
